import { render, staticRenderFns } from "./user-Notification.vue?vue&type=template&id=1d391343&scoped=true&"
import script from "./user-Notification.vue?vue&type=script&lang=js&"
export * from "./user-Notification.vue?vue&type=script&lang=js&"
import style0 from "./user-Notification.vue?vue&type=style&index=0&id=1d391343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d391343",
  null
  
)

export default component.exports